import { useFileContext } from '../contexts/FileContext';
import { getDraftRejectPhotoTag, getFinalRejectPhotoTag } from '../components/utils/moldOrder';
import { MoldOrder } from '../types/mold';
import { useEffect } from 'react';

const useMoldOrderFiles = (moldOrderId: number | null) => {
  const { 
    files, 
    loading, 
    error, 
    fetchFiles, 
    deleteFilesByTag 
  } = useFileContext();

  // Updated to use the moldOrder parameter to get the correct reject tag
  const hasRejectFile = ({
    isDraftState,
    moldOrder,
  }: {
    isDraftState: boolean;
    moldOrder?: MoldOrder
  }) => {
    if (!moldOrder) return false;
    const rejectPhotoTag = isDraftState ?  getDraftRejectPhotoTag(moldOrder): getFinalRejectPhotoTag(moldOrder);
    const filteredRejectFiles = files.filter(file => file.tag === rejectPhotoTag);
    return filteredRejectFiles.length > 0
  }

  return { 
    files, 
    loading, 
    error, 
    fetchFiles: () => moldOrderId && fetchFiles('mold_order', moldOrderId),
    hasRejectFile, 
    deleteFilesByTag,
  };
};

export default useMoldOrderFiles;
